import { Icon } from '@iconify/react';
import LogoScalar from '../../assets/img/logo-scalar2.png';
export default function Footer(){
    return(
        <>
            <footer className="bg-[#E6E6E6] border-t border-black/10 py-16 mt-auto">
                <div className="max-w-7xl mx-auto px-4">
                    <div className="flex flex-col items-center gap-4">
                        <img alt="Scalar" className="h-16 w-auto" src={LogoScalar}/>
                        <div className="flex items-center gap-4">
                            <a href="https://www.facebook.com/desarrollowebscalar" target="_blank" rel="noopener noreferrer" className="text-black/80 hover:text-[#1877F2] transition-colors">
                                <Icon icon="mdi:facebook" className="text-2xl" />
                            </a>
                            <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="text-black/80 hover:text-[#FF0000] transition-colors">
                                <Icon icon="mdi:youtube" className="text-2xl" />
                            </a>
                            <a href="https://www.tiktok.com/@scalardesarrolloamedida" target="_blank" rel="noopener noreferrer" className="text-black/80 hover:text-black transition-colors">
                                <Icon icon="ri:tiktok-fill" className="text-2xl" />
                            </a>
                            <a href="https://www.instagram.com/scalar19" target="_blank" rel="noopener noreferrer" className="text-black/80 hover:text-[#E4405F] transition-colors">
                                <Icon icon="mdi:instagram" className="text-2xl" />
                            </a>
                        </div>
                        <span className="text-black/80 text-sm">© todos los derechos reservados.</span>
                    </div>
                </div>
            </footer>
            <div className="ico-whatsapp-content">
                <a className='inline-flex justify-center items-center z-10 w-[100%] h-[100%]' href="https://api.whatsapp.com/send?phone=51946564003&amp;text=Me%20gustar%C3%ADa%20adquirir%20una%20p%C3%A1gina%20web&amp;source=&amp;data=" target="_blank" rel="noopener noreferrer">
                    <Icon icon="mdi:whatsapp" className="text-3xl" />
                </a>
            </div>
        </>
    )
}
